import { Key } from "@tonaljs/key";
import { majorKeys, minorKeys } from "../common/constants";
import { getRandomItem } from "./getRandomItem";

export function getRandomKey(): Key {
  const keys = [...minorKeys, ...majorKeys];

  return getRandomItem<Key>(keys);
}
